import { createApp } from 'vue';
import {BankAccountTransferForm} from "@/components/modules/BankAccountTransferForm";

document.addEventListener('DOMContentLoaded', () => {
	const form = document.getElementById('js-bank-account-transfer-form');

	if (form) {
		createApp(BankAccountTransferForm, {
			apiConfig: {
				endpoint: form.dataset.apiEndpoint,
				nonce: form.dataset.apiNonce,
			},
			formConfig: {
				action: "https://www.paymentstation.jp/customer/sf/at/kokkzmoshikomi/begin.do",
				version: "130",
				bill_method: "01",
				kessai_id: "0101",
				shop_cd: "6241959",
				syuno_co_cd: "20819",
				koushin_kbn: "1",
				shop_link: "https://realize-property.com/user/koufuri/?completed=1",
				shop_phon_hyoji_kbn: "0",
				shop_mail_hyoji_kbn: "0",
				shop_pwd: "TEeiJb72SM63",
				bill_mail_kbn: "0",

			}
		}).mount(form);
	}
});